// src/lib/layouts/cortesDefaults.ts
// Numbers derived from the CapCut Presset.1 combination preset (see
// docs/superpowers/specs/2026-07-11-cortes-capcut-layout-design.md).
import type { CortesGeometry, CortesTextStyle } from './types';

/** Rendered px of a text at anchor scale 1 on the 1080×1920 design canvas.
 * ≈ CapCut font_size 15 × 7 px/unit, estimated from Presset.1's cover. */
export const CORTES_BASE_TEXT_PX = 105;

/** CapCut's default text size; import normalizes sizes against this. */
export const CAPCUT_BASE_TEXT_SIZE = 15;

export const DEFAULT_CORTES_HEADLINE_STYLE: CortesTextStyle = {
  color: '#ffffff',
  strokeColor: '#000000',
  strokeWidth: 0.08,
  shadow: { color: '#000000', alpha: 0.9, distance: 5, angle: -45 },
  boxColor: '#ff0000',
  boxAlpha: 1,
  lineSpacing: 0.22,
};

export const DEFAULT_CORTES_HANDLE_STYLE: CortesTextStyle = {
  color: '#ffffff',
};

// Hand-tuned photo slots sit fully on-screen (an import replaces them with
// the preset's true, possibly overflowing, rects). Text anchors match
// Presset.1: y = 0.5 − transform.y / 2.
export const DEFAULT_CORTES_GEOMETRY: CortesGeometry = {
  photo1: { x: 0.05, y: 0.04, w: 0.42, h: 0.2 },
  photo2: { x: 0.53, y: 0.04, w: 0.42, h: 0.2 },
  photo3: { x: 0.02, y: 0.78, w: 0.42, h: 0.2 },
  photo4: { x: 0.56, y: 0.78, w: 0.42, h: 0.2 },
  headline: { x: 0.5, y: 0.25, scale: 0.5668 },
  handle: { x: 0.5, y: 0.70, scale: 0.3804 },
  clip: { x: 0, y: 0.38, w: 1, h: 0.34 },
};

/** Deep-ish clone for the cortes default blobs (plain JSON data, one level of nesting). */
export function cloneCortesDefaults<T>(value: T): T {
  return JSON.parse(JSON.stringify(value)) as T;
}
